import type { IDeprecatedService } from '~/types/deprecation'

import { DEPRECATED_SERVICES } from '~/const/deprecations'
import dayjs from '~/utils/dayjs'

/**
 * It returns the deprecated service the pathname belongs to, if any
 */
export const getDeprecatedService = (
  pathname: string,
  services: IDeprecatedService[] = DEPRECATED_SERVICES
): IDeprecatedService | undefined =>
  services.find(({ pathnamePrefixes }) =>
    pathnamePrefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))
  )

/**
 * It tells whether the service is no longer available on this intranet, i.e. its removal date has come
 */
export const isDeprecatedServiceRemoved = ({ removalDate }: IDeprecatedService, date = dayjs()): boolean =>
  !date.isBefore(removalDate, 'day')
